import { useMessageInstanceEvent as usePostOfficeContextMessageInstanceEvent } from '@atlassian/post-office-context/message-lifecycle';
import type { MessageInstanceEventHookScope } from '@atlassian/post-office-context/message-lifecycle';

export type { MessageInstanceEventHookScope } from '@atlassian/post-office-context/message-lifecycle';

export const useMessageInstanceEvent: () => MessageInstanceEventHookScope =
	usePostOfficeContextMessageInstanceEvent;
